import * as React from 'react';
import { SignUpInfo } from '../../models';
import { Link } from 'react-router-dom';
import { Telegram, Discord, Twitter, Youtube, Linkedin, Facebook, Medium, Email } from '../../assets/icons';
import { i18n } from '../../i18n';

interface SignUpFormProps {
  signUp: (info: SignUpInfo) => object,
  signUpError: string,
  hasSubmitted: boolean
}

class SignUpForm extends React.Component<SignUpFormProps> {
  public state = {
    name: '',
    email: '',
    signUpError: '',
    hasSubmitted: false
  }

  public componentWillReceiveProps(nextProps: SignUpFormProps) {
    this.setState({ signUpError: nextProps.signUpError, hasSubmitted: nextProps.hasSubmitted });
  }

  public handleChange = async (event: any) => {
    this.setState({
      [event.target.name]: event.target.value
    })
  }

  public handleSubmit = async (event: any) => {
    event.preventDefault();

    const signUpInfo: SignUpInfo = {
      name: this.state.name,
      email: this.state.email
    };

    this.props.signUp(signUpInfo);
  }

  public render() {
    return (
      <div className='content-body'>
        {this.state.signUpError !== '' && this.state.hasSubmitted && (
          <div className='error'>
            <p>{this.state.signUpError}</p>
          </div>
        )}
        {this.state.signUpError === '' && this.state.hasSubmitted && (
          <div className='thank-you-wrap'>
            <h2 className='title-underline'>{i18n.t('next_steps.signup_form.thanks_heading')}</h2>
            <p>{i18n.t('next_steps.signup_form.thanks_sub_heading')}</p>
            <Link className='link-button' to={{ pathname: '/' }}>{i18n.t('next_steps.signup_form.thanks_done_button_text')}</Link>
          </div>
        )}
        {(!this.state.hasSubmitted || this.state.signUpError !== '') && (
          <div>
            <h5>{i18n.t('next_steps.signup_form.heading')}</h5>
            <p>{i18n.t('next_steps.signup_form.instructions')}</p>
            <form onSubmit={this.handleSubmit}>
              <div className='signup-inputs-wrap'>
                <div className='input'>
                  <h6>{i18n.t('next_steps.signup_form.name_label')}</h6>
                  <input type='text' name='name' placeholder={i18n.t('next_steps.signup_form.name_placeholder')} value={this.state.name} onChange={this.handleChange} required={true} />
                </div>
                <div className='input'>
                  <h6>{i18n.t('next_steps.signup_form.email_label')}</h6>
                  <input type='email' name='email' placeholder={i18n.t('next_steps.signup_form.email_placeholder')} value={this.state.email} onChange={this.handleChange} required={true} />
                </div>
              </div>
              <button type='submit' className='button primary-button'>{i18n.t('next_steps.signup_form.submit_button_text')}</button>
            </form>
          </div>
        )}
        <div className='social-wrap'>
          <a href='https://t.me/gostackr' target='_blank'><Telegram /></a>
          <a href='https://discord.gg/PT7pfe9' target='_blank'><Discord /></a>
          <a href='https://twitter.com/Stackr_official' target='_blank'><Twitter /></a>
          <a href='https://www.youtube.com/channel/UCbecMaCTDKT6bL1erKGFfbw' target='_blank'><Youtube /></a>
          <a href='https://www.linkedin.com/company/gostackrofficial/' target='_blank'><Linkedin /></a>
          <a href='https://www.facebook.com/gostackr' target='_blank'><Facebook /></a>
          <a href='https://medium.com/stackr' target='_blank'><Medium /></a>
          <a href='mailto:info@stackr.com'><Email /></a>
        </div>
      </div>
    );
  }
}

export default SignUpForm;
